export function SciFiBackground() {
  return (
    <div className="pz-scifi" aria-hidden>
      <div className="pz-scifi__grid" />
      <div className="pz-scifi__orb o1" />
      <div className="pz-scifi__orb o2" />
      <div className="pz-scifi__orb o3" />
      <div className="pz-scifi__scan" />
    </div>
  );
}
